import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import {
  AggregationRegisterResponse,
  UnusedBalanceAggregationResponse,
} from '@/repositories/generated';

const aggregationResponse: UnusedBalanceAggregationResponse = {
  criteria: 'MONTHLY',
  records: [
    {
      dateTime: undefined,
      walletService: {
        id: '001',
        name: 'ウォレットサービス1',
      },
      issue: {
        chargeAmount: 30000,
        settlementAmount: 5000,
        adjustmentAmount: 0,
        totalAmount: 35000,
      },
      recovery: {
        expiredAmount: 0,
        chargeAmount: 20000,
        settlementAmount: 3000,
        adjustmentAmount: 0,
        totalAmount: 23000,
      },
      unusedBalanceAmount: 0,
      lastUnusedBalanceAmount: 0,
    },
    {
      dateTime: '2023-04-01T00:00:00+09:00',
      walletService: undefined,
      issue: {
        chargeAmount: 30000,
        settlementAmount: 5000,
        adjustmentAmount: 0,
        totalAmount: 35000,
      },
      recovery: {
        expiredAmount: 0,
        chargeAmount: 20000,
        settlementAmount: 3000,
        adjustmentAmount: 0,
        totalAmount: 23000,
      },
      unusedBalanceAmount: 0,
      lastUnusedBalanceAmount: undefined,
    },
  ],
  subtotal: {
    issue: {
      chargeAmount: 30000,
      settlementAmount: 5000,
      adjustmentAmount: 0,
      totalAmount: 35000,
    },
    recovery: {
      expiredAmount: 0,
      chargeAmount: 20000,
      settlementAmount: 3000,
      adjustmentAmount: 0,
      totalAmount: 23000,
    },
    unusedBalanceAmount: 0,
    lastUnusedBalanceAmount: 0,
  },
};

export const unusedBalanceAggregation = http.post(
  createMockEndpoint('/aggregation/unused_balance'),
  async () => {
    await delay(500);
    return HttpResponse.json(aggregationResponse, { status: 200 });
  },
);

const generateResponse: AggregationRegisterResponse = {
  id: '01G7BSJRS44QC70T7T96J70Q2K',
};

export const generateUnusedBalanceAggregationFile = http.post(
  createMockEndpoint('/aggregation/unused_balance/generate'),
  async () => {
    await delay(500);
    return HttpResponse.json(generateResponse, { status: 200 });
  },
);
